<template>
    <section id="services" class="services-area">
        <div class="container">
        <SectionContent :title="pageData.title" :subHeading="pageData.subheading" /> 
            <!-- All Service Wrapper-->
            <div class="row all-service-wrapper">

                <!--Single Service box Start-->
                <div class="col-12 col-sm-12 col-md-6 col-xl-4" v-for="(data, index) of services" :key="index">
                    <vue-aos animation-class="fadeInUp animated" :threshold="index/10">
                        <div class="single-service" >
                            <div class="hover-content"></div>
                            <img v-if="data.icon" :src="`${filePath}/${data.icon}`" :alt="data.heading">
                            <div class="single-service-content">
                                <h4>{{ data.heading }}</h4>
                                <p>{{ data.short_content.substring(0, 90) }}</p>
                                <router-link :to="`/${module}/${data.slug}`"><i class="flaticon-right-arrow"></i>See More</router-link>
                            </div>
                        </div>
                    </vue-aos>
                </div>
                <!--Single Service box End-->
            </div>
            <!-- All Service Wrapper-->
        </div>
    </section>
</template>

<script>
import VueAos from 'vue-aos'
import SectionContent from '../../components/Section-Content'

export default {
    components: { VueAos, SectionContent },
    data(){
        return {
            services: [],
            filePath: '',
            limit: 999,
            module: 'services',
            pageData: []
        }
    },
    methods: {
        async getData(){
            let params = {
                limit: this.limit
            }
            this.$http.get(`/services`, { params }).then(res=>{                
                if(res.status === 200 && res.data.result){
                    this.services = res.data.result
                    this.filePath = res.data.file_path
                    this.pageData = res.data.page_data
                }
            })
        }
    },
    created: function(){
        this.getData()
    }
}
</script>